module.exports = __webpack_public_path__ + "media/images/flags/1x1/chn-7bc8b0bf32f5fa6a8c3253ed64712eb6.svg";